"use strict";
exports.__esModule = true;
exports.PROPERTY_PASSTHROUGH_FEE = void 0;
exports.PROPERTY_PASSTHROUGH_FEE = {
    MODAL: {
        HEADER: 'Property passthrough fee',
        PARAGRAPH: 'Your property uses software that charges Flex to automatically pay rent on your behalf. A portion of this fee is passed through to you.',
        CTA_TEXT: 'Done'
    },
    PAYMENT_DETAILS_LABEL: 'Property passthrough fee',
    PAYMENT_SCHEDULE_DISCLAIMER: function (feeAmount) {
        return "\u2020Includes ".concat(feeAmount, " property passthrough fee");
    },
    PAYMENT_SCHEDULE_LINK_BUTTON: 'Learn more',
    PAYMENT_SCHEDULE_ICON: '†'
};
